export default __webpack_public_path__ + "static/Bäckerbild 2-c7d9dc11f922c9c94d5b7c33ff210162.jpg";